<template>
	<div>
		<edit v-if="$route.name == 'editDeliveryVariant'"/>
		<create v-if="$route.name == 'createDeliveryVariant'"/>
		<confirm-delete v-if="$route.name == 'deleteDeliveryVariant'" @onCancel="$router.back()" @onConfirm="deleteDeliveryVariant" :itemName="deleteItemName" />

		<e-table title="Delivery Variants" singularTitle="Delivery Variant" :data="$store.getters.deliveryVariants" :filter="filter" :columns="columns" @delete="confirmDelete" @setSortBy="val => {sortBy = val}" @setSortOrder="val => {sortOrder = val}"/>
	</div>
</template>

<script>
import Edit from '@/components/DeliveryVariant/Edit'
import Create from '@/components/DeliveryVariant/Create'
import Table from '@/components/Common/Table'
import ConfirmDelete from '@/components/Common/ConfirmDelete.vue'

export default {
	name: 'DeliveryVariants',
	components: {
		'edit': Edit,
		'create': Create,
		'e-table': Table,
		'confirm-delete': ConfirmDelete
	},
	data: () => ({
		sortBy: 'id',
		sortOrder: 'DESC',
		deleteItemName: '',
		filter: {
			name: {
				value: null,
				name: 'Name',
				property: 'name'
			},
			tag: {
				value: [],
				name: 'Tag'
			}
		},
		columns: [
			{
				name: 'id',
				label: 'ID'
			}, {
				name: 'name',
				label: 'Name'
			}, {
				name: 'description',
				label: 'Description'
			}, {
				name: 'tags',
				label: 'Tags',
				sortable: false
			}
		]
	}),
	async created() {
		try {
			await this.$store.dispatch('loadDeliveryVariants', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			await this.$store.dispatch('loadManifestFields')
		} catch (e) {
			this.$snackbar.showMessage(e)
		}
	},
	methods: {
		async confirmDelete(id) {
			const swv = await this.$store.getters.getDeliveryVariantById(id)
			this.deleteItemName = `${swv.name}`
			this.$router.push({name: 'deleteDeliveryVariant', params: {eid: id}})
		},
		async deleteDeliveryVariant() {
			try {
				this.showConfirmDelete = false
				await this.$apiService.deliveryVariant.delete(this.$route.params.eid)
				await this.$store.dispatch('loadDeliveryVariants', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.$router.back()
		}
	}
}
</script>
